import informationDanger from 'src/assets/images/icons/informationDanger.png';

import { CourierInvoiceDisputeDto } from 'src/generated/services/TFinancialApi';
import { DisputeTableIssues } from './DisputeTableIssues';
import { DisputeCardSelector } from './DisputeCardSelector';

export interface IContentContactProps {
  courierDetail?: CourierInvoiceDisputeDto;
  billedEntityId?: number;
}

export const ContentContact: React.FC<IContentContactProps> = ({ billedEntityId }) => (
  <>
    <div className='p-12 xl:p-16 bg-neutral-10 rounded-8 flex items-center gap-12 xl:gap-20'>
      <div className='w-36 xl:w-40'>
        <img src={informationDanger} alt='' className='w-full' />
      </div>

      <div className='flex-1'>
        <h3 className='text-16 xl:text-18 leading-20 xl:leading-24 mb-6 font-medium'>Contact Service Provider</h3>
        <p className='text-12 xl:text-14 leading-16 xl:leading-18 mb-6 text-blue_grey-80'>
          You need to <strong className='text-blue_grey-90 font-medium'>contact your Service Provider</strong> to review the invoice and agree on a resolution
          approach.
        </p>
      </div>
    </div>
    <DisputeTableIssues />
    <DisputeCardSelector billedEntityId={billedEntityId} />
  </>
);
